import { AuthPresenter } from '@presenters/containers/auth.presenter';
import React, { useEffect } from 'react';

const Login = () => {
    const presenter = new AuthPresenter();
    useEffect(() => 
        presenter.login(), []);

    return (
        <div>
            
        </div>
    )
}

export default Login;
